export interface LocationPath {
  siteCode?: string;
  warehouseCode?: string;
  zoneCode?: string;
  aisleCode?: string;
  rackCode?: string;
  bayCode?: string;
  levelCode?: string;
  binCode?: string;
}

export function BuildPathFromCode(locationCode: string): LocationPath {
  const segments = locationCode.split('.');
  return {
    siteCode: segments[0] || undefined,
    warehouseCode: segments[1] || undefined,
    zoneCode: segments[2] || undefined,
    aisleCode: segments[3] || undefined,
    rackCode: segments[4] || undefined,
    bayCode: segments[5] || undefined,
    levelCode: segments[6] || undefined,
    binCode: segments[7] || undefined,
  };
}
